import React from 'react';
import { HandHeart, Cpu, MessageCircle, Users } from 'lucide-react';
import { values } from '../../mock';

const iconMap = { HandHeart, Cpu, MessageCircle, Users };

export default function ValueStrip() {
  return (
    <section className="bg-[#FAF7F2] border-y border-[#0B0B0B]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 divide-x divide-[#0B0B0B]/10">
        {values.map((v) => {
          const Icon = iconMap[v.icon] || HandHeart;
          return (
            <div key={v.title} className="px-6 py-10 flex flex-col items-start gap-3">
              <Icon size={22} strokeWidth={1.4} className="text-[#0B0B0B]" />
              <div className="font-display text-xl text-[#0B0B0B]">{v.title}</div>
              <div className="text-sm text-[#0B0B0B]/65 leading-relaxed">{v.description}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
